import { pretty } from '../../lib/format'

export function Json({ value }: { value: unknown }) {
  const text = pretty(value)
  if (!text || text === '{}' || text === 'null' || text === '""') {
    return <p className="text-sm text-text-muted">—</p>
  }
  return (
    <pre className="max-h-96 overflow-auto rounded-md bg-gray-50 p-3 font-mono text-xs leading-relaxed text-text-default">
      {text}
    </pre>
  )
}
